import { render, staticRenderFns } from "./ShareStirpes.vue?vue&type=template&id=9a41038c"
import script from "./ShareStirpes.vue?vue&type=script&lang=js"
export * from "./ShareStirpes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports